// This function allow to reference all chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "app/" + ({"3057":"index","8516":"vizels"}[chunkId] || chunkId) + "." + __webpack_require__.h().slice(0, 4) + ".js";
};